module.exports = __webpack_public_path__ + "static/media/sublimetext.b267e71b.png";